// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Kl2U","choiceBoxes":"toolbarselects_choiceBoxes__27q79","simpleField":"toolbarselects_simpleField__lfjcQ"};